<div class="ui-g">
  <div class="ui-g-12">
    <h1 *ngIf="importDataType == 1">Import Drivers</h1>
    <h1 *ngIf="importDataType == 2">Import Trucks</h1>
    <h1 *ngIf="importDataType == 3">Import Suppliers</h1>
    <h1 *ngIf="importDataType == 4">Import Orders</h1>
    <h1 *ngIf="importDataType == 5">Import Non-Movement Transactions</h1>

    <p-tabView>
      <p-tabPanel header="Configuration">
        <import-config *ngIf="dataImportService.config != null"></import-config>
        <p-fileUpload
          name="file"
          url="/api/dataimport/import"
          accept=".csv,.xls,.xlsx"
          (onBeforeUpload)="onBeforeUpload($event)"
          (onUpload)="onUpload($event)"
          (onError)="onUploadError($event)"
          (onSelect)="onSelect($event)"
          (onClear)="onClear($event)"
          (onRemove)="onClear($event)"
          [disabled]="dataImportService.config == null"
        >
          <ng-template pTemplate="content">
            <div
              class="col-12 md:col-offset-4 md:col-4 lg:col-offset-4 lg:col-4 xl:col-offset-4 xl:col-4"
              *ngIf="!filesSelected"
            >
              <div ngClass="col-12">
                <i class="fa-3x fa fa-file-excel-o"></i> &nbsp; &nbsp;<span
                  >or you can drop the file here</span
                >
              </div>
            </div>
          </ng-template>
        </p-fileUpload>
      </p-tabPanel>
      <p-tabPanel header="Errors" *ngIf="invalidEntries.length">
        <import-errors [invalidEntries]="invalidEntries"></import-errors>
      </p-tabPanel>
      <p-tabPanel header="Imported Rows" *ngIf="validEntries.length">
        <import-result [validEntries]="validEntries"></import-result>
      </p-tabPanel>
    </p-tabView>
  </div>
</div>

<p-confirmDialog
  key="cd"
  header="Import result"
  icon="fa-icon-circle"
  [style]="{ width: '425px' }"
  [acceptVisible]="false"
  rejectLabel="Close"
></p-confirmDialog>
<p-dialog
  header="Uploading Files"
  [(visible)]="isUpLoading"
  [modal]="true"
  [responsive]="true"
  (onHide)="hideDialog()"
>
  <p-progressBar mode="indeterminate"></p-progressBar>
</p-dialog>
